var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("app-detail-header", {
        attrs: {
          "show-delete": false,
          "show-new": false,
          "show-save": false,
          "show-cancel": false,
          title: _vm.jcniObj[_vm.selectedJcni],
          "show-print": true,
        },
        on: { appDetailHeaderButtonClicked: _vm.handlePrint },
      }),
      _c("div", { staticClass: "tile is-ancestor is-parent" }, [
        _c(
          "div",
          { staticClass: "tile is-vertical is-parent" },
          [
            _c("jcni-menu-bar", {
              attrs: {
                "selected-jcni": _vm.selectedJcni,
                "is-loading": _vm.isLoading,
                data: _vm.jcniRecords,
                "include-gst": _vm.includeGst,
              },
              on: { change: _vm.handleJCNIEvent },
            }),
            _c(
              "div",
              { staticClass: "tile is-child box" },
              [
                _c(
                  "bulma-table",
                  {
                    ref: "jcnitable",
                    staticClass:
                      "is-striped is-narrow is-fullwidth is-hoverable",
                    attrs: {
                      columns: _vm.columns,
                      data: _vm.sortedData,
                      "total-rows": _vm.jcniRecords.length,
                      "page-size": _vm.jcniRecords.length,
                      "is-loading": _vm.isLoading,
                      "sort-column": _vm.sortColumn,
                      "sort-order": _vm.sortOrder,
                      "show-pagination": false,
                      "has-sticky-header": true,
                      "sticky-header-top": "9.5rem",
                    },
                    on: { sort: _vm.handleSort },
                  },
                  [
                    _vm._l(_vm.sortedData, function (job, index) {
                      return _c(
                        "tr",
                        {
                          key: index,
                          class: { "is-selected": _vm.selectedRow === index },
                          on: {
                            click: function ($event) {
                              return _vm.highlightSelected(index, $event)
                            },
                          },
                        },
                        [
                          _c("td", {}, [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.handleQuoteClick(job.quoteId)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(job.quoteNoRef))]
                            ),
                          ]),
                          _c("td", { staticClass: "has-text-left" }, [
                            _vm._v(_vm._s(job.jobStage)),
                          ]),
                          _c("td", { staticClass: "has-text-left" }, [
                            _vm._v(_vm._s(job.fullName)),
                          ]),
                          _c("td", { staticClass: "has-text-left" }, [
                            _vm._v(_vm._s(job.rego)),
                          ]),
                          _c("td", { staticClass: "has-text-left" }, [
                            _vm._v(_vm._s(job.insurer)),
                          ]),
                          _c("td", { staticClass: "has-text-centered" }, [
                            _vm._v(_vm._s(job.daysElapsed)),
                          ]),
                          _c("td", { staticClass: "has-text-left" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$filters.formatDateTimeLocale(
                                    job.jobEnd,
                                    _vm.$userInfo.locale
                                  )
                                ) +
                                " "
                            ),
                          ]),
                          _c("td", { staticClass: "has-text-right" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$filters.formatCurrency(
                                    job.jobTotal,
                                    _vm.$userInfo.locale
                                  )
                                ) +
                                " "
                            ),
                          ]),
                          _c("td", { staticClass: "has-text-right" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$filters.formatCurrency(
                                    job.debtorInvoice,
                                    _vm.$userInfo.locale
                                  )
                                ) +
                                " "
                            ),
                          ]),
                          _c("td", { staticClass: "has-text-right" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$filters.formatCurrency(
                                    job.excessInvoice,
                                    _vm.$userInfo.locale
                                  )
                                ) +
                                " "
                            ),
                          ]),
                          _c("td", { staticClass: "has-text-right" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$filters.formatCurrency(
                                    job.totalNotInvoiced,
                                    _vm.$userInfo.locale
                                  )
                                ) +
                                " "
                            ),
                          ]),
                          _c("td", { staticClass: "has-text-centered col-1" }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "button is-dark is-small is-inverted",
                                on: {
                                  mouseover: function ($event) {
                                    return _vm.getNotesContent(
                                      job.isNoteExists,
                                      job.quoteId
                                    )
                                  },
                                  mouseout: function ($event) {
                                    return _vm.resetNotesContent()
                                  },
                                  click: function ($event) {
                                    return _vm.notesClick(
                                      job.quoteId,
                                      job.quoteNoRef
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "tippy",
                                        rawName: "v-tippy",
                                        value: {
                                          enabled: _vm.showNoteContent,
                                          placement: "left-start",
                                          arrow: false,
                                          allowHTML: true,
                                        },
                                        expression:
                                          "{ enabled: showNoteContent, placement: 'left-start', arrow: false, allowHTML: true }",
                                      },
                                    ],
                                    staticClass: "icon is-medium",
                                    attrs: { content: _vm.notesContent },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "mdi mdi-24px",
                                      class: [
                                        job.isNoteExists
                                          ? "mdi-note-edit has-text-warning"
                                          : "mdi-note-edit-outline has-text-grey",
                                      ],
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]
                      )
                    }),
                    _c("template", { slot: "empty" }, [
                      _c("section", { staticClass: "section" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "content has-text-grey has-text-centered",
                          },
                          [
                            _c("span", { attrs: { icon: "icon is-large" } }, [
                              _c("i", {
                                staticClass: "mdi mdi-48px mdi-emoticon-sad",
                              }),
                            ]),
                            _c("p", [_vm._v("Nothing")]),
                          ]
                        ),
                      ]),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { ref: "notesList", staticClass: "is-hidden" }, [
        _c(
          "ul",
          {
            staticStyle: { "list-style-type": "disc", "padding-left": "1rem" },
          },
          _vm._l(_vm.notes, function (note, index) {
            return _c("li", { key: index }, [
              _c("span", { staticClass: "is-size-6" }, [
                _vm._v(_vm._s(note.remarks)),
              ]),
              _c(
                "div",
                { staticClass: "is-flex is-align-items-center is-size-7" },
                [
                  note.firstName || note.displayName
                    ? _c("user-profile-icon", {
                        staticClass: "pr-1",
                        attrs: {
                          "is-text-profile": true,
                          "first-name": note.firstName,
                          "last-name": note.lastName,
                          "display-name": note.displayName,
                          width: 20,
                          height: 20,
                        },
                      })
                    : _vm._e(),
                  _c("span", { staticClass: "help is-italic has-text-grey" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatDateTimeLocale(
                          note.remarkDateTime,
                          _vm.$userInfo.locale
                        )
                      )
                    ),
                  ]),
                ],
                1
              ),
            ])
          }),
          0
        ),
      ]),
      _vm.isNoteModalActive
        ? _c("note-modal", {
            attrs: {
              active: _vm.isNoteModalActive,
              "quote-id": _vm.selectedQuoteId,
              "job-no": _vm.selectedJobNo,
              "remark-type": _vm.remarkType,
              "remark-desc": _vm.remarkDesc,
            },
            on: {
              "update:active": function ($event) {
                _vm.isNoteModalActive = $event
              },
              close: _vm.closeNoteModal,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }